import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth/auth.service';
import { InputComponent } from '../../../components/form/input/input.component';

@Component({
  selector: 'app-login-private',
  standalone: true,
  imports: [CommonModule, InputComponent],
  templateUrl: './login-private.component.html',
  styleUrl: './login-private.component.scss'
})
export class LoginPrivateComponent {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/requests']);
    }
  }

  async loginPrivate() {
    const url = await this.authService.initLoginPrivate();
    window.location.href = url;
    //this.router.navigate(['/exceptions']);
  }
}
